module.exports = __webpack_public_path__ + "static/media/triangle.b683e164.svg";